export enum FormMode {
  VIEW = 'VIEW',
  NEW = 'NEW',
  EDITING = 'EDITING',
}
